/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TeamSettingAuthorizationResource } from './';
import {
    TeamSettingAuthorizationResourceFromJSON,
    TeamSettingAuthorizationResourceFromJSONTyped,
    TeamSettingAuthorizationResourceToJSON,
} from './';
import type { TeamSettingInvitationLinkStateResource } from './';
import {
    TeamSettingInvitationLinkStateResourceFromJSON,
    TeamSettingInvitationLinkStateResourceFromJSONTyped,
    TeamSettingInvitationLinkStateResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientTeamSettingsUpdateRequest
 */
export interface ClientTeamSettingsUpdateRequest {
    /**
     * 
     * @type {TeamSettingAuthorizationResource}
     * @memberof ClientTeamSettingsUpdateRequest
     */
    membersListAccessAuthorization: TeamSettingAuthorizationResource;
    /**
     * 
     * @type {TeamSettingAuthorizationResource}
     * @memberof ClientTeamSettingsUpdateRequest
     */
    invitationSendingAuthorization: TeamSettingAuthorizationResource;
    /**
     * 
     * @type {TeamSettingInvitationLinkStateResource}
     * @memberof ClientTeamSettingsUpdateRequest
     */
    invitationLinkState: TeamSettingInvitationLinkStateResource;
    /**
     * 
     * @type {string}
     * @memberof ClientTeamSettingsUpdateRequest
     */
    clientCompanyId: string;
}

/**
 * Check if a given object implements the ClientTeamSettingsUpdateRequest interface.
 */
export function instanceOfClientTeamSettingsUpdateRequest(value: object): value is ClientTeamSettingsUpdateRequest {
    if (!('membersListAccessAuthorization' in value) || value['membersListAccessAuthorization'] === undefined) return false;
    if (!('invitationSendingAuthorization' in value) || value['invitationSendingAuthorization'] === undefined) return false;
    if (!('invitationLinkState' in value) || value['invitationLinkState'] === undefined) return false;
    if (!('clientCompanyId' in value) || value['clientCompanyId'] === undefined) return false;
    return true;
}

export function ClientTeamSettingsUpdateRequestFromJSON(json: any): ClientTeamSettingsUpdateRequest {
    return ClientTeamSettingsUpdateRequestFromJSONTyped(json, false);
}

export function ClientTeamSettingsUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientTeamSettingsUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'membersListAccessAuthorization': TeamSettingAuthorizationResourceFromJSON(json['membersListAccessAuthorization']),
        'invitationSendingAuthorization': TeamSettingAuthorizationResourceFromJSON(json['invitationSendingAuthorization']),
        'invitationLinkState': TeamSettingInvitationLinkStateResourceFromJSON(json['invitationLinkState']),
        'clientCompanyId': json['clientCompanyId'],
    };
}

export function ClientTeamSettingsUpdateRequestToJSON(value?: ClientTeamSettingsUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'membersListAccessAuthorization': TeamSettingAuthorizationResourceToJSON(value['membersListAccessAuthorization']),
        'invitationSendingAuthorization': TeamSettingAuthorizationResourceToJSON(value['invitationSendingAuthorization']),
        'invitationLinkState': TeamSettingInvitationLinkStateResourceToJSON(value['invitationLinkState']),
        'clientCompanyId': value['clientCompanyId'],
    };
}

